import axios from './axiosService';
import { RootService } from "./rootService";
import { logger } from '../utils';
import { GetPermissionCheckTimeModel, SetUserTimeDto } from "../models";

/**
 * Сервис, отвечающий за проверку синхронизации времени пользователя с серверным.
 */
export class TimeSyncService {
    root: RootService;

    constructor(root: RootService) {
        this.root = root;
    }

    /**
     * Метод для получения согласия проверки синхронизации времени
     */
    async getIsAllowCheckTime(): Promise<GetPermissionCheckTimeModel>{
        try {
            const response = await axios.get<GetPermissionCheckTimeModel>(`timeSync/status`)
            const data = response.data;
            return Promise.resolve(data);
        } catch (error: any){
            logger.error(error);
            return Promise.reject(error);
        }
    }

    /**
     * Метод для получения времени с сервера
     */
    async getServerTime(body: SetUserTimeDto): Promise<any>{
        try {
            const response = await axios.post(`timeSync/check_time`, body)
            const data = response.data;
            return Promise.resolve(data);
        } catch (error: any){
            logger.error(error);
            return Promise.reject(error);
        }
    }
}
